import api from '@/api';
import {
  YardReportListRequest,
  YardReportListResponse,
  YardReportRequest,
} from './yard-report.types';

const path = '/visual-management/yard-report';

export default {
  async list(params?: YardReportListRequest) {
    const result = (await api.get(path, params)) as unknown;

    return result as YardReportListResponse;
  },

  async report(params?: YardReportRequest) {
    const result = (await api.getReport(path, params)) as unknown;

    return result as BlobPart;
  },
};
